import { currentPatientSelector } from '../selectors/patients-selectors.ts';

module.exports = class ReasonService {
  static $inject = [
    '$ngRedux',
    'ProductService',
  ];

  constructor($ngRedux, ProductService) {
    this.$ngRedux = $ngRedux;
    this.ProductService = ProductService;
    this.initializeStateConnection();
  }

  initializeStateConnection() {
    this.$ngRedux.connect(state => ({
      patient: currentPatientSelector(state),
    }))(this);
  }

  isReasonUnaccessible(reason) {
    const hasAuthorizedProfessionalsProduct = this.ProductService.isAvailable('PATIENT_AUTHORIZED_PROFESSIONALS');
    const hasNoAuthorizedAccounts = !this.patient.subscription.authorizedAccounts || this.patient.subscription.authorizedAccounts.length === 0;
    return reason.deactivated || (hasAuthorizedProfessionalsProduct && reason.accountFilter === 'optional' && !this.patient.subscription.account && hasNoAuthorizedAccounts);
  }
};



// WEBPACK FOOTER //
// ./main/services/reason-service.js